
window.addEventListener('load', () => {

  var $videos = $('.video-js');

  $videos.each(function(i, el) {
    var $vid = $(el);
    var vidId = $vid.attr('id');

    videojs(vidId,{
      fluid: true
    }).ready(function(){

      this.tech_.off('dblclick');

      $vid.click(function() {
        if (this.paused) {
          this.play();
        } else {
          this.pause();
        }
      });

    });


  });


});
